// Unpublished Work © 2025 Deere & Company.

import {SET_CUSTOMER_VISIBILITY_REMOVED_STATUS} from '../../action-list';

const setCustomerVisibilityRemovedStatus = (state, action) => action.isCustomerVisibilityRemoved;

export function isCustomerVisibilityRemoved(state = false, action = {}) {
    const actionHandlers = {
        [SET_CUSTOMER_VISIBILITY_REMOVED_STATUS]: setCustomerVisibilityRemovedStatus
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
